import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../styles/Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <Container>
        <Row className={styles.row}>
          <Col sm={6} className={styles.brandCol}>
            <p className={styles.brand}>NEKO WEB STUDIOS</p>
            <p className={styles.tagline}>Websites that work as hard as you do.</p>
          </Col>
          <Col sm={6} className={styles.contactCol}>
            <a href="tel:8120100041" className={styles.link}>+91 81201 00041</a>
            <a href="mailto:mathuresha@nekowebstudios.com" className={styles.link}>
              mathuresha@nekowebstudios.com
            </a>
          </Col>
        </Row>
        <div className={styles.bottom}>
          &copy; {new Date().getFullYear()} Neko Web Studios. All rights reserved.
        </div>
      </Container>
    </footer>
  );
}
